import { render, staticRenderFns } from "./ResourcesResearchContent.vue?vue&type=template&id=1ce54163&"
import script from "./ResourcesResearchContent.vue?vue&type=script&lang=js&"
export * from "./ResourcesResearchContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports